export default __webpack_public_path__ + "static/4-unit-testing-a73e49ea8dab6d7d1900340194b28fa3.png";